import React, { useState } from "react";
import { ToolDescription, ToolsContainer } from "../styles";
import { FieldsGeneralSettings } from "./selector-sections/fields-general-settings";
import { FieldsGeneralSettingsContainer } from "./selector-sections/fields-general-settings-container";
import { FieldsLabels } from "./selector-sections/fields-labels";
import { PaymentButtonSetting } from "./selector-sections/payment-button-setting";
import { PaymentMethodSettings } from "./selector-sections/payment-method-settings";
import { SelectorField } from "./selector-sections/selector-field";
import { TabSelector } from "./selector-sections/tab-selector";
import { WrapperSections } from "./selector-sections/wrapper-sections";
import { useTranslation } from "react-i18next";

export const PaymentForm = () => {
  const [tab, setTab] = useState(0);
  const { t } = useTranslation();

  const handleChange = (index) => {
    setTab(index);
  };

  return (
    <ToolsContainer>
      <ToolDescription>{t("styles.paymentsDesc")}</ToolDescription>

      <TabSelector index={tab} onChange={handleChange} />

      {tab === 0 ? (
        <WrapperSections>
          {/*     <FieldsGeneralSettings />
          <FieldsLabels />
          <SelectorField /> */}
          <PaymentMethodSettings />
        </WrapperSections>
      ) : (
        <WrapperSections>
          <FieldsGeneralSettingsContainer />
        </WrapperSections>
      )}
    </ToolsContainer>
  );
};
